import React from 'react';
import { CheckCircle, Clock, AlertCircle, Eye, Download } from 'lucide-react';
import Button from '../../../components/common/Button';

const DocumentStatusCard = ({ title, documents, status, icon: Icon, action }) => {
  const statusConfig = {
    verified: { 
      color: 'text-green-600 bg-green-50 border-green-200',
      icon: CheckCircle,
      label: 'Verified'
    },
    pending: { 
      color: 'text-yellow-600 bg-yellow-50 border-yellow-200',
      icon: Clock,
      label: 'Pending'
    },
    rejected: { 
      color: 'text-red-600 bg-red-50 border-red-200',
      icon: AlertCircle,
      label: 'Needs Attention'
    }
  };

  const getDocumentDisplayName = (documentName) => {
    // Extract filename from the path and remove email prefix if present
    const filename = documentName.split('/').pop() || documentName;
    // Remove email prefix if it exists (e.g., "email@example.com - uploaded_files/")
    const cleanName = filename.replace(/^[^-]+ - /, '');
    // Remove file extension and format
    return cleanName
      .split('.')[0]
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  const getStatusDetails = (doc) => {
    if (status === 'verified') {
      return {
        verifiedBy: doc.verified_by_email !== '-' ? doc.verified_by_email : null,
        verificationDate: doc.verification_date_formatted !== '-' ? doc.verification_date_formatted : null
      };
    }
    
    if (status === 'rejected') {
      return {
        rejectionReason: doc.rejection_reason || 'No reason provided'
      };
    }
    
    return {};
  };

  const handleViewDocument = (doc) => {
    console.log('View document:', doc);
  };

  const StatusIcon = statusConfig[status].icon;

  return (
    <div className="bg-white rounded-xl shadow-sm border p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-2 rounded-lg ${statusConfig[status].color}`}>
          <Icon className="w-5 h-5" />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500">
            {documents.length} document{documents.length !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
      
      <div className="space-y-3">
        {documents.map((doc) => {
          const statusDetails = getStatusDetails(doc);
          
          return (
            <div 
              key={doc.id} 
              className="p-3 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-sm font-medium text-gray-900 truncate">
                      {getDocumentDisplayName(doc.document_name)}
                    </span>
                    <div className={`px-2 py-1 rounded-full text-xs font-medium ${statusConfig[status].color}`}>
                      {statusConfig[status].label}
                    </div>
                  </div>
                  
                  {/* Status-specific details */}
                  {status === 'verified' && statusDetails.verifiedBy && (
                    <div className="text-xs text-gray-600 space-y-1">
                      <p>Verified by: {statusDetails.verifiedBy}</p>
                      {statusDetails.verificationDate && (
                        <p>On: {statusDetails.verificationDate}</p>
                      )}
                    </div>
                  )}
                  
                  {status === 'rejected' && (
                    <div className="text-xs text-red-600">
                      <p className="font-medium">Reason: {statusDetails.rejectionReason}</p>
                    </div>
                  )}
                  
                  {status === 'pending' && (
                    <div className="text-xs text-yellow-600">
                      <p>Awaiting admin review</p>
                    </div>
                  )}
                </div>
                
                <div className="flex items-center gap-1 ml-3">
                  {/* <Button
                    variant="link"
                    size="sm"
                    onClick={() => handleViewDocument(doc)}
                    className="text-gray-500 hover:text-gray-700 p-1"
                  >
                    <Eye className="w-4 h-4" />
                  </Button> */}
                  
                  {/* <Button
                    variant="link"
                    size="sm"
                    onClick={() => handleDownloadDocument(doc)}
                    className="text-gray-500 hover:text-gray-700 p-1"
                  >
                    <Download className="w-4 h-4" />
                  </Button> */}
                </div>
              </div>
              
              {/* Original filename (small and muted) */}
              <div className="mt-2">
                <p className="text-xs text-gray-400 truncate">
                  {doc.document_name}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default DocumentStatusCard;